module.exports = new __parcel__URL__("floor-tom_7.68418ad4.mp3").toString();